import { TFunction } from 'react-i18next';

import { useMappedTranslation } from 'hooks/useMappedTranslation';

import { getMappedTranslation } from 'utility/Translate/mappedTranslation';

import { ViewType } from 'proto/Offer/Accommodation/ViewType';

const viewTypeTranslationKeyMap: Partial<Record<ViewType, string>> = {
    [ViewType.SeaView]: 'TRANS-ocean-view',
    [ViewType.LateralSeaView]: 'TRANS-partial-ocean-view',
    [ViewType.GardenView]: 'TRANS-garden-view',
    [ViewType.PoolView]: 'TRANS-pool-view',
    [ViewType.LandView]: 'TRANS-land-view',
};

export const useViewLabel = (viewType: ViewType | undefined) =>
    useMappedTranslation(viewTypeTranslationKeyMap, viewType);

export const buildViewLabel = (viewType: ViewType | undefined, t: TFunction) =>
    getMappedTranslation(viewTypeTranslationKeyMap, viewType, t);
